export default {
  apiUrl: '/api/grapes',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'grape-editor',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name',
      title: '<i style="white-space: nowrap">한글 이름</i>',
      sortField: 'name',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'name_en',
      title: '<i style="white-space: nowrap">영어 이름</i>',
      sortField: 'name_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'grape_dsc_subtitle',
      title: '<i style="white-space: nowrap">설명 주제</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'grape_dsc',
      title: '<i style="white-space: nowrap">설명</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'subStringField',
    },
    {
      name: 'img_grape',
      title: '<p style="white-space: nowrap">품종 이미지</p>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imgField',
    },
    {
      name: 'is_checked',
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: 'is_checked',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/grape/Config.js